import React, { useState, cloneElement } from 'react';
import { List, CreateButton, RefreshButton, TopToolbar, Datagrid, TextField, DateField, ShowButton, Filter, TextInput, SelectInput, usePermissions, useResourceContext, DateInput, useRecordContext } from 'react-admin';
// import { DateInput } from 'react-admin-date-inputs';
import { Scrollbars } from 'react-custom-scrollbars';
import Spinner from '../../src/spinner';
import myDataProvider from '../myRestProvider';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Modal from 'react-responsive-modal';

const selectInputStyle = {
    width: 200,
};

const InAppFilter = (props) => (
    <Filter {...props}>
        <TextInput source="title" />
        <TextInput source="purpose" />
        <TextInput source="admin_email" />
        <TextInput source="admin_name" />
        <SelectInput source="job_status" choices={[
            { id: 'Complete', name: 'Complete' },
            { id: 'Queued', name: 'Queued' },
            { id: 'Working', name: 'Working' },
        ]}
        />
        <SelectInput style={selectInputStyle} 
        // label="Target type" 
        source="target_type" choices={[
            { id: 'Country', name: 'All Retailers' },
            { id: 'Business', name: 'A set of Retailers' },
        ]}
        />
        <DateInput source="uploaded_date_from" 
        // label="Uploaded date from" 
        />
        <DateInput source="uploaded_date_to" 
        // label="Uploaded date to" 
        />
    </Filter>
);

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
    display: 'block',
    width: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

};

const ListActions = ({ filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
    const resource = useResourceContext()
    console.log("resource", resource);
    console.log("filterValues", filterValues);
    console.log("showFilter", showFilter);
    console.log("displayedFilters", displayedFilters);
    console.log("filters", filters);
    return (
        <TopToolbar>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={resource} />
            <RefreshButton />
        </TopToolbar>
    )
}

const InAppNotificationList = (props) => {
    // state = {
    //     modalShow: false,
    // }
    const [modalShow, setModalShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');


    const exporter = (data) => {
        const msg = data[0].message;
        setModalShow(true);
        setModalMsg(msg)
    }

    const onClose = () => {
        setModalShow(false);

    }
    const permissions = usePermissions();

    const NameField = ({ source }) => {
        const record = useRecordContext();
        return (
            <span>{record[source] === '-' ? '-' : (record[source] ? record[source] : '-')}</span>
        )
    }

    return (
        <>
            <Scrollbars className="scroll-container" >
                <List
                    {...props}
                    exporter={exporter}
                    sort={{ field: 'created_at', order: 'DESC' }}
                    filters={<InAppFilter />}
                    title="Notification"
                    actions={<ListActions permissions={permissions} />}
                >
                    <Datagrid rowClick={false} bulkActionButtons={false}>
                        <TextField source="purpose" style={textFieldStyle} allowEmpty />
                        <TextField source="title" style={textFieldStyle} allowEmpty />
                        <TextField source="type" sortable={false} allowEmpty />
                        <TextField source="job_status" />
                        <NameField source="admin_name" />
                        <TextField source="admin_email" />
                        {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                        <DateField source="created_at" showTime />
                        <ShowButton />
                    </Datagrid>
                </List>
            </Scrollbars>
            {
                modalShow &&
                <Modal open={modalShow} onClose={onClose} center>
                    <h3>{modalMsg}</h3>
                </Modal>
            }
        </>
    )

}

export default InAppNotificationList;